import { atalhoTheme } from 'reapop';

const statusColors: Record<string, { bg: string; text: string; icon: string; border: string }> = {
  success: { bg: '#e8f5e9', text: '#2e7d32', icon: '#2e7d32', border: '#c8e6c9' },
  error: { bg: '#ffebee', text: '#c62828', icon: '#c62828', border: '#ffcdd2' },
  warning: { bg: '#fff8e1', text: '#f57f17', icon: '#f57f17', border: '#ffecb3' },
  info: { bg: '#e3f2fd', text: '#1565c0', icon: '#1565c0', border: '#bbdefb' },
  loading: { bg: '#e3f2fd', text: '#1565c0', icon: '#1565c0', border: '#bbdefb' }
};

export const notificationTheme = {
  ...atalhoTheme,
  notification: (notification: any) => {
    const colors = statusColors[notification.status];
    const base = atalhoTheme.notification(notification);
    if (!colors) {
      return base;
    }

    return {
      ...base,
      backgroundColor: colors.bg,
      border: `1px solid ${colors.border}`,
      boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)',
      color: colors.text
    };
  },
  notificationIcon: (notification: any) => ({
    ...atalhoTheme.notificationIcon(notification),
    color:
      statusColors[notification.status]?.icon || atalhoTheme.notificationIcon(notification).color
  }),
  notificationTitle: (notification: any) => ({
    ...atalhoTheme.notificationTitle(notification),
    color: statusColors[notification.status]?.text || '#ffffff'
  }),
  notificationMessage: (notification: any) => ({
    ...atalhoTheme.notificationMessage(),
    color: statusColors[notification.status]?.text || '#b9c2cb'
  }),
  // Atalho buttons are dark and truncate labels — recolor to the status
  // palette and let the label wrap.
  notificationButton: (notification: any, position: any, state: any) => {
    const colors = statusColors[notification.status];
    const base = atalhoTheme.notificationButton(notification, position, state);
    if (!colors) {
      return base;
    }

    return {
      ...base,
      background: colors.bg,
      borderLeft: `1px solid ${colors.border}`,
      borderTop: position === 1 ? `1px solid ${colors.border}` : 'none',
      color: colors.text,
      fontWeight: 600,
      textDecoration: state.isHovered || state.isActive ? 'underline' : 'none'
    };
  },
  notificationButtonText: (notification: any, position: any, state: any) => ({
    ...atalhoTheme.notificationButtonText(notification, position, state),
    height: 'auto',
    whiteSpace: 'normal',
    overflow: 'visible',
    textOverflow: 'clip',
    lineHeight: 1.3,
    padding: '8px 12px'
  })
};
